import { JSONContent } from '@tiptap/react';
import { flowEditorState } from '../flowEditorState';

/**
 * we use this to make sure all content in the editor is wrapped in a dBlock
 */
export const sanitizeTiptapContent = (tiptap: JSONContent) => {
  const sanitizedContent = tiptap.content?.map((block) => {
    if (block.type === 'dBlock') {
      return block;
    }
    return {
      type: 'dBlock',
      content: [block],
      attrs: {
        personaId: block.attrs?.personaId ?? flowEditorState.defaultPersonaId,
      },
    };
  });
  return {
    ...tiptap,
    content: sanitizedContent ?? [],
  };
};
